import { Component, inject, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthService } from './application/services/auth.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent implements OnInit {
  title = 'Pharma CRM';
  private authService = inject(AuthService);

  ngOnInit(): void {
    // Valida la sesión contra el servidor al cargar la app.
    // Si el token expiró, el error interceptor maneja el refresh o el logout.
    if (this.authService.isAuthenticated()) {
      this.authService.validateSession().subscribe({ error: () => {} });
    }
  }
}
